module.exports = "/_next/static/images/bb950d51e34e186b9c185523c7ac8e56-aboutus-ed.jpg.webp";